"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var styles = {
  "menu": "MenuActions__menu__27ETX"
}; 
require('./MenuActions.css');
var MenuActions = function MenuActions(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)(-1),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    itemFocused = _useState2[0],
    setItemFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(-1),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    subItemFocused = _useState4[0],
    setSubItemFocused = _useState4[1];
  var childRefs = [];
  var _getNextIndex = function getNextIndex(actualIndex, length) {
    var next;
    if (actualIndex === -1) {
      next = 0;
    } else {
      next = actualIndex === length - 1 ? 0 : actualIndex + 1;
    }
    if (!childRefs[next]) {
      return _getNextIndex(next, length);
    }
    return next;
  };
  var _getPreviousIndex = function getPreviousIndex(actualIndex, length) {
    if (actualIndex === -1) {
      return length - 1;
    }
    var prev = actualIndex === 0 ? length - 1 : actualIndex - 1;
    if (!childRefs[prev]) {
      return _getPreviousIndex(prev, length);
    }
    return prev;
  };
  var nextIndexFn = {
    ArrowUp: _getPreviousIndex,
    ArrowDown: _getNextIndex
  };
  var handleKeyDown = function handleKeyDown(event) {
    var newItemFocused;
    var subNewItemFocused;
    var eventKey = event.key;
    var length = childRefs.length;
    if (eventKey === 'ArrowDown' || eventKey === 'ArrowUp') {
      event.preventDefault();
      newItemFocused = subItemFocused === -1 ? nextIndexFn[eventKey](itemFocused, length) : itemFocused;
      var element = childRefs[newItemFocused];
      if (Array.isArray(element)) {
        subNewItemFocused = nextIndexFn[eventKey](subItemFocused, element.length);
        element[subNewItemFocused].focus();
        if (element.length - 1 === subNewItemFocused && eventKey === 'ArrowDown' || subNewItemFocused === 0 && eventKey === 'ArrowUp') {
          subNewItemFocused = -1;
        }
        setSubItemFocused(subNewItemFocused);
      } else {
        setSubItemFocused(-1);
        element.focus();
      }
      setItemFocused(newItemFocused);
    }
  };
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: styles.menu,
    role: "menu",
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, _react.default.Children.map(children, function (child, index) {
    if (/*#__PURE__*/_react.default.isValidElement(child)) {
      var _child$type;
      var displayName = (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName;
      if (displayName === 'MenuItem') {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          getRef: function getRef(element) {
            childRefs[index] = element;
          },
          tabIndex: '-1'
        });
      }
      if (displayName !== null && displayName !== void 0 && displayName.includes('Actions')) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          addRef: function addRef(element, childIndex) {
            if (childRefs[index]) {
              childRefs[index][childIndex] = element;
            } else {
              childRefs[index] = [element];
            }
          }
        });
      }
    }
    return child;
  }));
};
var _default = exports.default = MenuActions;
//# sourceMappingURL=MenuActions.js.map